// Form Validation
(function() {
    'use strict';
    window.addEventListener('load', function() {
      
        sessionStorage.removeItem("submit_type");
      	//console.log("");
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
              sessionStorage.setItem("submit_type", "submit");
              doValidate(form, event);                
            }, false);
          
          	form.querySelector("#form-submit").addEventListener("click", function(event){
              if(sessionStorage.getItem("submit_type") === "submit"){
              	return false;                          
              }
              sessionStorage.setItem("submit_type", "click");              
		      doValidate(form, event);   
            }, false);
        });

        /*crear nuevos formularios*/
        var formulariosCatalogos = document.getElementsByClassName('formularioCatalogos');
            
          var formulariosContacto = document.getElementsByClassName('contact-forms');

        var formulariosContactoCita = document.getElementsByClassName('contact-forms-cita');

       var formulariosDiseno = document.getElementsByClassName('formulario-Diseno');
      
      var formProductos = document.getElementsByClassName('formulario-Productos');
      
       for (var i = 0; i < formProductos.length; i++) {
         formProductos[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "formProductos");
           setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }
      
        for (var i = 0; i < formulariosContacto.length; i++) {
         formulariosContacto[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "formulariosContacto");
           setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }

                         for (var i = 0; i < formulariosContactoCita.length; i++) {
         formulariosContactoCita[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "formulariosContactoCita");
 setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }



      
        //console.log("listener");
        for (var i = 0; i < formulariosCatalogos.length; i++) {
          formulariosCatalogos[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "interes-catalogos-home");

            
            //alert("sendLeadPrototype");
            // Envía el formulario manualmente después de ejecutar la función
            this.submit();
            //sendLeadPrototype(this, "interes-catalogos-home");
          });
        }

              //console.log("listener") diseno interior;
        for (var i = 0; i < formulariosDiseno.length; i++) {
          formulariosDiseno[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "interes-diseno-home");

            
            //alert("sendLeadPrototype");
            // Envía el formulario manualmente después de ejecutar la función
            this.submit();
            //sendLeadPrototype(this, "interes-diseno-home");
          });
        }
      
        
    }, false);
})();










function doValidate(form, event){
    
	//console.log("submitted form");

    var formId = form.id;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      //console.log('form validation Failed');	                  
      $("input.form-control").each(function(){
        if($(this).is(":invalid")){
          $(this).parent().addClass("invalid");
        } else {
          $(this).parent().removeClass("invalid");
        }
      });
    } else {
      //console.log('form validation Succesful');
      $("#form-submit", form).text("Enviando...");
      $("#form-submit", form).addClass('disabled');                    

      sendLeadPrototype(form, formId);
    }
    form.classList.add('was-validated');
}

function sendLeadPrototype(ref, id) {
    //console.log(id);
    var agencia = window.agenciaFormData;

    // URL de API
    var url_api = "https://adpdev.com/adp/mx/seguimiento/index.php";

    // Nodo meta del body request
    var meta = { "action": "create-lead-para-usuarios-cartas", "version": "5.0" };

    // Construye el dataset
    //var dataset = buldDataset();
    var dataset = {};

    // Grabar valores en dataset del cliente
    dataset.info = {};
    dataset = buldDatasetSettings(dataset, agencia);
    
    /**
    * C Ó D I G O   C U S T O M
    * ------------------------------------------
    */
    // // Anteponer al comentario la fecha y hora sugeridas
    var precomentario = '';

    if(id == "interes-catalogos-home"){
        dataset.nombre       = ref.querySelector("input[name='contact[first_name]']").value;
        dataset.apellidos    = ref.querySelector("input[name='contact[last_name]']").value;
        dataset.email        = ref.querySelector("input[name='contact[email]']").value;
        dataset.telefono     = ref.querySelector("input[name='contact[phone]']").value;

        dataset.asunto = "Formulario Catálogos Akabani";
        dataset.typ = "https://akabani-mexico.myshopify.com/pages/catalogos";
        precomentario = "Interesado en Catálogo Akabani";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("catalogLead", "true");
    }
    else if(id == "formProductos"){
        dataset.nombre       = ref.querySelector("input[name='contact[name]']").value;
        dataset.apellidos    = ref.querySelector("input[name='contact[last_name]']").value;
        dataset.email        = ref.querySelector("input[name='contact[email]']").value;
        dataset.telefono     = ref.querySelector("input[name='contact[phone]']").value;
        dataset.comentarios  = ref.querySelector("textarea[name='contact[body]']").value;
    }
    else if(id == "interes-diseno-home"){
        dataset.nombre       = ref.querySelector("input[name='contact[first_name]']").value;
        dataset.apellidos    = ref.querySelector("input[name='contact[last_name]']").value;
        dataset.email        = ref.querySelector("input[name='contact[email]']").value;
        dataset.telefono     = ref.querySelector("input[name='contact[phone]']").value;

        dataset.asunto = "Formulario Diseño de interiores Akabani";
        dataset.typ = "https://akabani-mexico.myshopify.com/pages/diseno-de-interiores";
        precomentario = "Interesado en Diseño de Interiores";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("catalogLead", "true");
    }
    else if(id == "formulariosContactoCita"){

        console.log("inicia if");    
        
        // Solo para este formulario validamos existencia antes de pedir .value
        dataset.nombre       = ref.querySelector("input[name='contact[name]']")?.value || "";
        dataset.apellidos    = ref.querySelector("input[name='contact[last_name]']")?.value || "";
        dataset.email        = ref.querySelector("input[name='contact[email]']")?.value || "";
        dataset.telefono     = ref.querySelector("input[name='contact[phone]']")?.value || "";
        dataset.comentarios  = ref.querySelector("textarea[name='contact[body]']")?.value || "";

        console.log( dataset.comentarios );
   
        dataset.asunto = "Formulario Cita Showroom Akabani";
        dataset.typ = "https://akabani.com/pages/contacto-cita";
        
        // Validacion segura para campos especificos de cita
        dataset.sucursal = ref.querySelector("select[name='contact[sucursal]']")?.value || "";
        dataset.fecha = ref.querySelector("input[name='contact[dia]']")?.value || "";
        dataset.hora = ref.querySelector("select[name='contact[hora]']")?.value || "";
        
        precomentario = `Reserva de cita en showroom ${dataset.sucursal} el ${dataset.fecha} a las ${dataset.hora}:00 hrs`;
        dataset.id_formatoTipo = 4;
        localStorage.setItem("contactlogLead", "true");

        console.log("termina if");    
    }
    
    else if(id == "formulariosContacto"){

        console.log("inicia if");    
        dataset.nombre       = ref.querySelector("input[name='contact[name]']").value;
        dataset.apellidos    = ref.querySelector("input[name='contact[last_name]']").value;
        dataset.email        = ref.querySelector("input[name='contact[email]']").value;
        dataset.telefono     = ref.querySelector("input[name='contact[phone]']").value;
        dataset.comentarios  = ref.querySelector("textarea[name='contact[body]']").value;

        console.log( dataset.comentarios );
   
        dataset.asunto = "Formulario Contacto Akabani";
        dataset.typ = "https://akabani.com/pages/contacto";
        precomentario = "Interesado en Contacto Akabani";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("contactlogLead", "true");

        console.log("termina if");    
    }
    else{
      // Información capturada por el lead
      dataset.nombre               = $('#contact-firstname', ref).val();
      dataset.apellidos           = $('#contact-lastname', ref).val();
      dataset.email               = $('#contact-email', ref).val();
      dataset.telefono            = $('#contact-phone', ref).val();
      dataset.comentarios         = $('#contact-comments', ref).val();
      dataset.cp                  = "";
    }
  
    // Información de producto
    //dataset.productname = $('#contact-comments', ref).attr("data-producttitle");
    //dataset.producturl = $('#contact-comments', ref).attr("data-producturl");

    // URL del formulario de conversión
    dataset.info.conversion_form =  window.location.href;

    // console.log(dataset);
    // return false;

    // Switch de id´s de formulario
    switch (id) {
        case "interes-catalogos-home":
        dataset.asunto = "Formulario Catálogos Akabani";
        dataset.typ = "https://akabani-mexico.myshopify.com/pages/catalogos";
        precomentario = "Interesado en Catálogo Akabani";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("catalogLead", "true");
            break;
        
        case "interes-producto":
          dataset.asunto = "Interesado en Producto";
          if(dataset.productname && dataset.producturl){
            precomentario = '<br><b>Producto:</b> ' + dataset.productname;
            precomentario += '<br><b>Url:</b> ' + '<a href="https://'+window.location.hostname + dataset.producturl+'" target="_blank">'+dataset.producturl+'</a>';
          }
          
          dataset.id_formatoTipo = 4;
          break;
       
        case "interes-diseno-home":
        dataset.asunto = "Formulario Diseño de interiores Akabani";
        dataset.typ = "https://akabani-mexico.myshopify.com/pages/diseno-de-interiores";
        precomentario = "Interesado en Diseño de Interiores";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("catalogLead", "true");
            break;

        case "formulariosContactoCita":
        dataset.asunto = "Formulario Cita Showroom Akabani";
        dataset.typ = "https://akabani.com/pages/contacto-cita";
        
        // Tambien aqui aplicamos validacion segura para que no truene el switch
        dataset.sucursal = ref.querySelector("select[name='contact[sucursal]']")?.value || "";
        dataset.fecha = ref.querySelector("input[name='contact[dia]']")?.value || "";
        dataset.hora = ref.querySelector("select[name='contact[hora]']")?.value || "";
        
        precomentario = `Reserva de cita en showroom ${dataset.sucursal} el ${dataset.fecha} a las ${dataset.hora}:00 hrs`;
        dataset.id_formatoTipo = 4;
        localStorage.setItem("contactlogLead", "true");
            break;        

        case "formulariosContacto":
        dataset.asunto = "Formulario Contacto Akabani";
        dataset.typ = "https://akabani.com/pages/contacto";
        precomentario = "Interesado en Contacto Akabani";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("contactlogLead", "true");
            break;        

        case "formProductos":
        dataset.asunto = "Formulario Productos Akabani";
        dataset.typ = "https://akabani.com/products/";
        precomentario = "Interesado en Productos Akabani";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("contactlogLead", "true");
            break;        

        default:
            dataset.asunto = "Interesado en Contacto General";
            dataset.id_formatoTipo = 4;
            break;
    }

    dataset.comentarios = (dataset.comentarios) ? dataset.comentarios += " " + precomentario : precomentario;

    // Suscribir a Newsletter
    /*if($("#newsletter_optin").is(':checked')){
        dataset.id_newsletterEstado = 1;
    }else{
        dataset.id_newsletterEstado = 0;
    }*/

    dataset.template_testing = true;

    //--------------------------------------------

    var allreq = { "meta": meta, "dataset": dataset };
    var stringjson = JSON.stringify(allreq);
    //console.log("BUZON REQUEST DEBUG:");
    //console.log(allreq);

    var error = false;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url_api, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);
            //console.log("BUZON RESPONSE DEBUG:");
            //console.log(data);
            
            if (data.meta.status !== "ok") {
                // Error al intentar enviar
                // document.getElementById("boton-enviar").value = "Ocurrió un problema :(";
            } else {
                // Envío exitoso
                // document.getElementById("boton-enviar").value = "¡Excelente!";
                var form_tipo = data.dataset.id_formatoTipo;
                var id_suscriber = "";
                
                if (typeof data.dataset.idx_suscriber !== "undefined" && data.dataset.idx_suscriber !== null && data.dataset.idx_suscriber !== "") {
                    id_suscriber = data.dataset.idx_suscriber;
                }
                
                if (dataset.typ) {
                    //window.location.href = dataset.typ;
                } else {
                    //redirectTyp(form_tipo, id_suscriber);
                }
            }
        }
    };
    xhr.send(stringjson);
}

function redirectTyp(form_tipo,id_suscriber){
    var tipo;

    switch(form_tipo){
        case 1:
            tipo = 'general';
            break;

        default:
            tipo = 'general';
            break;
    }
    var url = "/pages/gracias?t=" + tipo;
    if(typeof id_suscriber !== "undefined" && id_suscriber != null && id_suscriber != "NULL" && id_suscriber != ""){
        url = url + "&adpmetrics_u=" + id_suscriber;
    }
    window.location.href = url;
}


function buldDatasetSettings(dataset, agencia){

    //var agencia_seguimiento_id = $('#contact-agencia').val();
    //var agencia_cartacx_id     = $('#contact-agencia').find(":selected").attr('data-cartasid');
    //var agencia_name           = $('#contact-agencia').find(":selected").text();

    // URL del Home de la landing
    dataset.dominio = window.location.hostname;

    // ¿Asunto fijo? (Si el asunto es fijo, no funcionarán los replys de mail, email piping)
    dataset.asunto_fixed = false;

    // Template para transeccionales de registro de nuevo lead
    dataset.email_notify_enduser = null;
    dataset.email_notify_backoffice = null;

    // From para envío de transaccionales
    dataset.from_mail_buzon = "seguimiento@crmautomotriz.com";
    dataset.from_address_agencia_buzon = "Akabani";

    // Nombre de la agencia para mostrar en transaccionales
    dataset.agencia_nombre = "Akabani";

    if (document.location.search == "?formtest=true") {
        // ID Agencia de DB Prueba de manejo Adpunto
        dataset.id_agencia = 1;

        // ID Cliente de DB Cartas Adpunto
        dataset.id_agencia_cartas = 15;
    } else {
        // ID Agencia de DB Prueba de manejo Adpunto
        dataset.id_agencia = 57;

        // ID Cliente de DB Cartas Adpunto
        dataset.id_agencia_cartas = 74;
    }


    // ID del tipo de status inicial, para el lead, de DB Prueba Manejo
    dataset.id_statusNuevo = 1;

    //Campaign properties
    try {
      var properties = {
        campaign_source: "campaign_source",
        campaign_name: "campaign_name",
        campaign_medium: "campaign_medium",
        campaign_agency: "campaign_agency",
        campaign_term: "campaign_term",
        campaign_content: "campaign_content",
        referrer_path: "referrer_path",
        url_completa: "url_completa",
        ip: "ip",
        device: "device"
      };
      
      for (var prop in properties) {
        if(typeof adpuntoUtils !== "undefined" ){
          if(typeof adpuntoUtils.Cookies !== "undefined"){
            if(typeof adpuntoUtils.Cookies.get !== "undefined"){
              if(typeof adpuntoUtils.Cookies.get(properties[prop]) !== "undefined" && adpuntoUtils.Cookies.get(properties[prop])!= "" ){
                dataset[prop] = adpuntoUtils.Cookies.get(properties[prop]);
              }
              if(typeof adpuntoUtils.Cookies.get("history") !== "undefined" && adpuntoUtils.Cookies.get("history")!= "" ){
                dataset.info.history = adpuntoUtils.Cookies.get("history");
              }
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }

    return dataset;
}

function setDisclaimerText(){
    var submit_text = $("#form-submit").text();
    var disclaimer  = "";
    disclaimer += '<div id="privacy-disclaimer">';
    disclaimer += 'Al dar clic en "'+ submit_text + '", aceptas nuestro ';
    disclaimer += '<a target="_blank" href="/aviso-de-privacidad">aviso de privacidad</a>.';
    disclaimer += '</div>';

    if($("#form-submit").length){
        $("#form-disclaimer").html(disclaimer);
    }
}


/*Abrir chat*/
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
	  	/*purechatApi.on('chatbox:ready', function () {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const getInitChat = urlParams.get('initchat');
			if(typeof getInitChat !== 'undefined' && getInitChat == "chat"){
				purechatApi.set('chatbox.expanded', true); // Expanded the chat box (false collapses it)
			}

			const getNombre = urlParams.get('name');
			if(typeof getNombre !== 'undefined'){
				purechatApi.set('visitor.name', getNombre); // Sets the visitor name to "Joe Doe"
			}

			const getEmail = urlParams.get('email');
			if(typeof getEmail !== 'undefined'){
				purechatApi.set('visitor.email', getEmail); // Sets the visitor name to "Joe Doe"
			}

			const getPhone = urlParams.get('phone');
			if(typeof getPhone !== 'undefined'){
				purechatApi.set('visitor.phoneNumber', getPhone); // Sets the visitor name to "Joe Doe"
			}

			const get_utm_source = urlParams.get('utm_source');
			const get_utm_medium = urlParams.get('utm_medium');
			if(typeof get_utm_source !== 'undefined' && get_utm_source =="adpmx" &&  typeof get_utm_medium !== 'undefined' && get_utm_medium =="email"){
				purechatApi.set('visitor.question', 'Estoy interesado en las promociones que llegaron a mi email');
			}
		});*/
	}, "2000");
});
	

